import { titles } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	checkbox: {
		margin: '20px 0',
	},
	checkboxContainer: {},
	checkboxText: {
		letterSpacing: 1.1,
		paddingLeft: 14,
		paddingRight: 20,
		width: 250,
	},
	container: {
		maxHeight: '100%',
		overflow: 'auto',
	},
	industrySelect: {},
	label: {
		color: titles,
		fontSize: 14,
		margin: '12px 0',
	},
	triggerContainer: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
	},
	triggerLabel: {
		borderRight: '1px solid rgb(216,216,216)',
		color: '#D1d1d1',
		fontSize: 12,
		height: '100%',
		letterSpacing: 1.1,
		paddingLeft: 10,
		paddingRight: 10,
		paddingTop: 24,
		textTransform: 'uppercase',
		width: 80,
	},
	triggerValue: {
		paddingLeft: 10,
	},
});
